import { displayCurrentLevel } from './membership-level-groups';
import { AmountSelection } from '../../modules/amount-selection';
import { nodeListToArray } from '../../../Content/helpers/nodeListToArray';
// Custom amount checkbox used by multiple things
export const customAmountInput = document.getElementById('SfoMembershipRequest_Donation') as HTMLInputElement;
export const invalidAmountError = document.querySelector('[data-amount-invalid-error]') as HTMLElement;
export const pageAnchors = document.querySelectorAll('[data-membership-anchor]');

export const initializeAmounts = (updateSubmitButtonCallback: (amt: number) => void) => {
    if (customAmountInput) {
        const donationAmountsList = nodeListToArray(document.querySelectorAll('[data-donation-radios]'));

        let allRadios = [];
        if (donationAmountsList) {
            donationAmountsList.forEach((list) => {
                allRadios = [].slice.call(list.querySelectorAll('input[type="radio"]'));
                console.log(allRadios);
                allRadios.forEach(radio => radio.addEventListener('change', (event) => {
                    updateSubmitButtonCallback?.(event.target.value);
                    customAmountInput.value = radio.value;
                }))
                new AmountSelection(customAmountInput, allRadios);
            })
        }

        customAmountInput.addEventListener('blur', () => {
            const newValue = parseInt(customAmountInput.value);
            if (isNaN(newValue) || newValue < 0) {
                customAmountInput.value = '0';
                invalidAmountError.removeAttribute('hidden');
            }
            else {
                invalidAmountError.setAttribute('hidden', '');
                allRadios.forEach(radio => {
                    if (radio.value == newValue)
                        radio.checked = true;
                    else
                        radio.checked = false;

                })
                updateSubmitButtonCallback?.(newValue);
            }
            displayCurrentLevel(newValue);
           
        });
    }
}
